//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MiniNavBar from '@/components/MiniNavBar.vue';
import VideoWrapper from '@/components/VideoWrapper.vue';
export default {
    components: { MiniNavBar, VideoWrapper },
    beforeRouteEnter(to, from, next) {
        const params = to.params;
        // console.log(params);
        const obj = {
            introduction: 0,
            guide: 1,
            customs: 2,
            video: 3
        };
        next((vm) => {
            vm.getTypes();
            vm.getIntro();
            vm.getGuideList();
            vm.getCustom();
            vm.getVideoList();
            if (params.anchor && !params.id) {
                vm.currentItem = obj[params.anchor];
            }
        });
    },
    data() {
        return {
            banner: '',
            typeList: [],
            currentItem: 0,
            introduction: '',
            guideList: [],
            videoList: [],
            custom: ''
        };
    },
    computed: {
        transX() {
            return this.currentItem * -100 + '%';
        }
    },
    methods: {
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 1
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.typeList = res.data;
                }
            });
        },
        getIntro() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '7'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.introduction = res.data.content;
                }
            });
        },
        getGuideList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '8',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.guideList = res.data.data;
                }
            });
        },
        getVideoList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '28',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.videoList = res.data.data;
                }
            });
        },
        getCustom() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '9'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.custom = res.data.content;
                }
            });
        },
        tryToPlay(url) {
            url = encodeURIComponent(url);
            this.$router.push('./video-player?src=' + url);
        }
    }
};
